import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/audible': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M640 199.9v54l-320 200-320-199.9v-54l320 200zM445.5 271.9c-70.8-94.4-200.5-110.7-290.2-36.3-2.6 2.2-5.2 4.4-7.7 6.7h-0.3c37.1-55.7 100.6-92.4 172.6-92.4s135.5 36.8 172.7 92.6zM225.4 290.7c21-29.6 55.5-49 94.4-49 39.2 0 73.9 19.6 94.8 49.5l-45.4 28.4c-21.2-29.2-52-47.6-86.4-47.6-20.9 0-40.5 6.8-57.4 18.7zM103.6 161.1c-11.5 9.1-24.3 22.1-34.2 32.6 53.9-82.1 147-135.6 250.5-135.6 104.9 0 197.2 54 250.7 135.7l-48.8 30.4-0.7-1c-99.3-138.5-285.7-166.4-417.5-62.1zM570.6 193.8z'
      }
    ]
  }
})
